// File: src/pages/website/index.js
// Main website page - now using new HomePage component

import React from 'react';
import HomePage from './HomePage';

export default function WebsitePage() {
  return <HomePage />;
}